import Data from '../Api/Data'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TCompanyDM from './TCompanyDM'

export default class TCompanyLinkDM extends Data {
	public static className = 'TCompanyLinkDM'
	public static systemFields = [
		'RecordID',
	]

	IsValid?: string
	ChangedOn?: Date
	RecordNumber?: number
	TableId?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	IconCalc?: number
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TCompanyDM)
	CompanyId?: TCompanyDM
}